import { ContainerModule } from 'inversify';
import { configModule } from '@allocate/config/DI/configModule';
import { domainModule } from '@framework/config/DI/domainModule';
import { messageManagerModule } from './modules/messageManagerModule';
import { DispatcherModule as UsersDispatcherModule } from '@users/json-rpc-dispatcher';
import { DispatcherModule as DmPortalDispatcherModule } from '@dm-portal/json-rpc-dispatcher';
import { FileDownloadLinkGeneratorModule as DmPortalFileDownloadModule } from '@dm-portal/file-download-link-generator';
import { DispatcherModule as CondorDispatcherModule } from '@condor/json-rpc-dispatcher';
import { AllocateDispatcherModule } from '@allocate/json-rpc-dispatcher';
import { serverCookiesModule, clientCookiesModule } from '@framework/config/DI/cookiesModule';
import { serverReqClientDataModule, clientReqClientDataModule } from '@framework/config/DI/reqClientDataModule';
import { nonceModule } from '@framework/config/DI/nonceModule';
import { ICookies } from '@framework/router/Next/cookie/ClientCookie';
import { IClientReqData } from '@framework/router/Next/headers/ClientReqData';

interface IData {
  cookie?: ICookies,
  headers?: IClientReqData,
}

export const rootModules: ContainerModule[] = [
  domainModule,
  configModule,
  messageManagerModule,
  UsersDispatcherModule,
  DmPortalDispatcherModule,
  DmPortalFileDownloadModule,
  CondorDispatcherModule,
  AllocateDispatcherModule,
];

export const clientContainerModules = ({ cookie, headers }: IData = {}) => ([
  ...rootModules,
  clientCookiesModule(cookie),
  clientReqClientDataModule(headers),
  nonceModule,
]);

export const serverContainerModules = [
  ...rootModules,
  serverCookiesModule,
  serverReqClientDataModule,
  nonceModule,
];
